<template>

  <div class="alert-wrapper">
    <div v-for="alert in alerts"
         v-show="alert.show"
         class="alert"
         transition="alert"
         @click="hide(alert)"
         role="alert">
      <strong>{{ messageTitle(alert) }}</strong> {{ alert.message }}
    </div>
  </div>
</template>

<style lang="sass">
  @import '../../assets/scss/colors'
  @import '../../assets/scss/variables'

  .alert-wrapper
    position: fixed
    right: 5em
    top: 5em
    z-index: 10

    .alert
      background: $white
      margin: 1em auto 0 auto
      cursor: pointer
      border: 1px solid $grey-507

    .alert-transition
      transition: all 0.5s ease
      overflow: hidden

    .alert-enter,
    .alert-leave
      opacity: 0

  @media screen and (max-width: map_get($grid-breakpoints, "md"))

    .alert-wrapper
      right: auto
      top: 1em
      display: flex
      flex-direction: column
      width: 100%

</style>

<script>
  export default {
    data () {
      return {
        defaults: {
          danger: {
            css: 'alert-danger',
            title: 'Error!'
          },
          error: {
            css: 'alert-danger',
            title: 'Error!'
          },
          info: {
            css: 'alert-info',
            title: 'Info:'
          },
          success: {
            css: 'alert-success',
            title: 'Success!'
          },
          warning: {
            css: 'alert-warning',
            title: 'Warning!'
          }
        }
      }
    },
    methods: {
      hide(alert) {
        alert.show = false;
      },

      messageTitle(alert) {
        if (alert.title != '') {
          return alert.title;
        } else if (alert.type) {
          return this.defaults[alert.type].title;
        }
        return '';
      }
    },
    vuex: {
      getters: {
        alerts: state => state.alerts
      }
    }
  }
</script>



// WEBPACK FOOTER //
// alerts.vue?16205c09